import GTM from '../../../../helpers/GTM'

interface Discount {
  applied: boolean
  code: string
}

interface Coupon {
  discounts: Discount[]
}

interface CartData {
  modifiers?: {
    coupon?: Coupon
  }
}

const trackApplyCouponInCart = (data: CartData): void => {
  if (!data?.modifiers?.coupon) {
    // No coupon associated with the cart
    return
  }

  const { coupon } = data.modifiers
  const { discounts } = coupon
  const discountApplied = discounts?.filter((discount) => discount?.applied)

  if (discountApplied && discountApplied.length > 0) {
    const [{ code }] = discountApplied
    const { applyCoupon } = GTM
    applyCoupon(code)
  }
}

export default trackApplyCouponInCart
